import {
  AlertCircleFilled, CaretDown, CaretUp, Plus, Print, Return
} from '@nike/nike-design-system-icons';
import PropTypes from 'prop-types';
import React from 'react';

const iconPropTypes = {
  size: PropTypes.string,
};

const iconDefaultProps = {
  size: 's',
};

export const CaretUpIcon = ({ size = 's' }) => <CaretUp className="eds-color--secondary" size={size} />;
CaretUpIcon.propTypes = iconPropTypes;
CaretUpIcon.defaultProps = iconDefaultProps;

export const CaretDownIcon = ({ size = 's' }) => <CaretDown className="eds-color--secondary" size={size} />;
CaretDownIcon.propTypes = iconPropTypes;
CaretDownIcon.defaultProps = iconDefaultProps;

export const PlusIcon = ({ size = 's' }) => <Plus className="eds-color--secondary" size={size} />;
PlusIcon.propTypes = iconPropTypes;
PlusIcon.defaultProps = iconDefaultProps;

export const WarningIcon = ({ size = 's' }) => <AlertCircleFilled color="#D30005" size={size} />;
WarningIcon.propTypes = iconPropTypes;
WarningIcon.defaultProps = iconDefaultProps;

export const PrintIcon = ({ size = 's' }) => <Print size={size} />;
PrintIcon.propTypes = iconPropTypes;
PrintIcon.defaultProps = iconDefaultProps;

export const ReturnIcon = ({ size = 's' }) => <Return size={size} />;
ReturnIcon.propTypes = iconPropTypes;
ReturnIcon.defaultProps = iconDefaultProps;
